export const options = [
  { label: 'Diário', value: '1' },
  { label: 'Semanal', value: '7' },
  { label: 'Quinzenal', value: '15' },
  { label: 'Mensal', value: '30' },
]
